import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import ServicesGrid from './components/ServicesGrid';
import ProjectGallery from './components/ProjectGallery';
import WhyChooseUs from './components/WhyChooseUs';
import AboutSection from './components/AboutSection';
import TestimonialShowcase from './components/TestimonialShowcase';
import ServiceAreas from './components/ServiceAreas';
import ProcessTimeline from './components/ProcessTimeline';
import CostPlanningGuide from './components/CostPlanningGuide';
import EstimateCTA from './components/EstimateCTA';
import FAQ from './components/FAQ';
import LocalAuthority from './components/LocalAuthority';
import PreFooterCTA from './components/PreFooterCTA';

export default function Home() {
  return (
    <>
      <Hero />
      <TrustBar />
      <ServicesGrid />
      <ProjectGallery />
      <WhyChooseUs />
      <AboutSection />
      <TestimonialShowcase />
      <CostPlanningGuide />
      <ServiceAreas />
      <ProcessTimeline />
      <EstimateCTA />
      <FAQ />
      <LocalAuthority />
      <PreFooterCTA />
    </>
  );
}